import { useEffect, useMemo } from 'react';
import { type IRuntimeWidgetAdvancedOption } from '../IAdvancedSelectWidget.ts';

interface IUseShowOnlySelectedFilterParams {
  dataSource: IRuntimeWidgetAdvancedOption[];
  selectedIds: string[];
  showOnlySelected: boolean;
  onToggle?: () => void;
}

/**
 * Hook per gestire il filtro "Mostra solo selezionate"
 */
export function useShowOnlySelectedFilter(
  props: IUseShowOnlySelectedFilterParams,
) {
  const { dataSource, selectedIds, showOnlySelected, onToggle } = props;

  const filteredDataSource = useMemo(() => {
    if (!showOnlySelected) return dataSource;
    if (selectedIds.length === 0) return [];

    const selectedSet = new Set(selectedIds);
    return dataSource.filter(option => selectedSet.has(option.id));
  }, [dataSource, selectedIds, showOnlySelected]);

  useEffect(() => {
    onToggle?.();
  }, [showOnlySelected]);

  return {
    filteredDataSource,
  };
}
